import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { listVideosService } from "../../../../services/video";
import VideoItem from "./VideoItem";

export default function Category({ category, titleBg, other }) {
  const nav = useNavigate();

  const handleVideoClick = (videoId) => {
    nav(`/video/${videoId}`);
  };

  const { isPending, data } = useQuery({
    queryKey: ["data", category?.categoryId || category?.id || 0],
    queryFn: () =>
      listVideosService({
        limit: 3,
        categoryId: category?.categoryId || category?.id,
        otherCategory: other,
      }),
  });

  let list = data?.data?.filter((e) => e.id !== category?.videoId);
  return (
    <Box sx={{ position: "relative" }}>
      {titleBg && (
        <Box
          sx={{
            width: 1,
            height: "150px",
            position: "absolute",
            top: 0,
            zIndex: -1,
          }}
        >
          <img
            src={titleBg}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "top center",
            }}
            alt=""
          />
        </Box>
      )}
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "2em",
            ...(titleBg ? { pt: "60px", mt: 2 } : {}),
          }}
        >
          <Typography variant="h4" sx={{ color: "#323232" }}>
            {category?.name || "other"}
          </Typography>
          <Grid container spacing={2}>
            {isPending && (
              <Grid item xs={12} justifyContent="center">
                <CircularProgress />
              </Grid>
            )}

            {list?.map((video) => (
              <Grid item xs={12} md={4}>
                <VideoItem
                  key={video?.id}
                  video={video}
                  handleVideoClick={handleVideoClick}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
